// extracted by mini-css-extract-plugin
export default {"addSongWraper":"EditLyric_addSongWraper__rR2jB","formError":"EditLyric_formError__6T4M-","input":"EditLyric_input__g4lVF","submitButton":"EditLyric_submitButton__+KemZ"};